import {useForm, FormProvider} from "react-hook-form";
import * as Yup from 'yup'
import {yupResolver} from '@hookform/resolvers/yup'
import {Datalist, NumberInput, Select} from "./inputs";
import Checkbox from "./inputs/Checkbox";
import {useEffect} from "react";
import {useSelector} from "react-redux";
import packageJson from '../../package.json'
import {getRalColorsOptions} from "../misc/helpers";
import {Link} from "react-router-dom";
import {Routes as R} from "../utils";



const schema = Yup.object({
    product: Yup.object().required(),
    width: Yup.number().required(),
    height: Yup.number().required(),
    align: Yup.string().required(),
    topEnabled: Yup.bool().default(false),
    depth: Yup.number().required(),
    openingDirection: Yup.string().required(),
    openingType: Yup.string().required(),
    color: Yup.object().required(),
    type: Yup.string().required(),
    doorstep: Yup.string().required(),
    glass: Yup.string().required(),
    lock: Yup.string().required(),
    border: Yup.string().required(),
    handle: Yup.string().required(),
    biggerBottomBorder: Yup.bool().default(false),
    topBorder: Yup.number(),
    bottomBorder: Yup.number(),
})

export const options = {
    depth: [
        {label: '52mm klat.', value: 52},
        {label: '75mm zewn.', value: 75},
        {label: '85mm bezp.', value: 85},
        {label: '100mm zewn.', value: 100},
    ],
    openingDirection: [
        {label: 'Lewe', value: 'left'},
        {label: 'Prawe', value: 'right'},
    ],
    openingType: [
        {label: 'Do środka', value: 'inside'},
        {label: 'Na zewnątrz', value: 'outside'},
    ],
    panelCount: [
        {label: 'Drzwi + jedno naświetle boczne', value: 1},
        {label: 'Drzwi + dwa naświetla boczne', value: 2},
    ],
    color: getRalColorsOptions(),
    // color: [
    //     {label: 'Winchester', value: 'winchester.png', img: `${packageJson.homepage}/img/colors/winchester.png`},
    //     {label: 'Złoty dąb', value: 'zloty_dab.png', img: `${packageJson.homepage}/img/colors/zloty_dab.png`},
    //     {label: 'Dąb', value: 'dab.png', img: `${packageJson.homepage}/img/colors/dab.png`},
    //     {label: 'Afromozja', value: 'afromozja.png', img: `${packageJson.homepage}/img/colors/afromozja.png`},
    //     {label: 'Kasztan', value: 'kasztan.png', img: `${packageJson.homepage}/img/colors/kasztan.png`},
    //     {label: 'Złoty dab classic', value: 'zloty_dab_classic.png', img: `${packageJson.homepage}/img/colors/zloty_dab_classic.png`},
    //     {label: 'Jasny orzech', value: 'jasny_orzech.png', img: `${packageJson.homepage}/img/colors/jasny_orzech.png`},
    //     {label: 'Jasny palisander', value: 'jasny_palisander.png', img: `${packageJson.homepage}/img/colors/jasny_palisander.png`},
    //     {label: 'Stary Dab', value: 'stary_dab.png', img: `${packageJson.homepage}/img/colors/stary_dab.png`},
    //     {label: 'Orzech PCV', value: 'orzech_pcv.png', img: `${packageJson.homepage}/img/colors/orzech_pcv.png`},
    //     {label: 'Dab bagienny', value: 'dab_bagienny.png', img: `${packageJson.homepage}/img/colors/dab_bagienny.png`},
    //     {label: 'Ciemny orzech', value: 'ciemny_orzech.png', img: `${packageJson.homepage}/img/colors/ciemny_orzech.png`},
    // ],
    type: [
        {label: 'Dąb standard', value: 'dab_standard'},
        {label: 'Gładkie', value: 'gladkie'},
    ],
    doorstep: [
        {label: 'Aluminiowy', value: 'aluminiowy'},
        {label: 'Aluminiowy plus nakładki', value: 'aluminiowy_plus_nakladkami'},
        {label: 'Drewniany', value: 'drewniany'},
    ],
    glass: [
        {label: 'Lustro Weneckie', value: 'lustro_weneckie'},
        {label: 'Piaskowane', value: 'piaskowane'},
        {label: 'Wypukłe', value: 'wypukle'},
        {label: 'Mleczne', value: 'mleczne'},
        {label: 'Okienne', value: 'okienne'},
        {label: 'Refleks brąz', value: 'refleks_braz'},
        {label: 'Refleks bezbarwny', value: 'refleks_bezbarwny'},
    ],
    lock: [
        {label: 'Standard', value: 'standard'},
        {label: 'Listwowy automatyczny', value: 'listwowy_automatyczny'},
        {label: 'Listwowy hakowy', value: 'listwowy_hakowy'},
        {label: 'Listwowy 4 pkt.', value: 'listwowy_4pkt'},
    ],
    border: [
        {label: 'Czarny', value: 'czarny'},
        {label: 'Srebrny', value: 'srebrny'},
        {label: 'Stare złoto', value: 'stare_zloto'},
    ],
    handle: [
        {label: 'Antaba kwadratowa', value: 'antaba_kwadratowa'},
        {label: 'Antaba łukowa', value: 'antaba_lukowa'},
        {label: 'Antaba okrągła', value: 'antaba_okragla'},
        {label: 'AXA ROYAL', value: 'axa_royal'},
        {label: 'Hoppe London', value: 'hoppe_london'},
        {label: 'Standard', value: 'standard'},
    ],
};


export default function AdvancedConfigurationForm(props) {
    const store = useSelector(({main}) => ({
        products: main.products,
        config: main.config,
        dimensions: main.dimensions,
    }))
    const formMethods = useForm({
        mode: 'onChange',
        resolver: yupResolver(schema),
        defaultValues: {
            ...schema.getDefault(),
            ...props.config,
        },
    })

    useEffect(() => {
        const subscription = formMethods.watch(data => {
            if(Number(data.panelCount) === 1) {
                if(data.openingDirection === 'left') {
                    data.align = 'left'
                } else {
                    data.align = 'right'
                }
            } else {
                data.align = 'center'
            }
            return formMethods.handleSubmit(() => props.onSubmit(data))()
        });
        return () => subscription.unsubscribe();
    }, [formMethods.watch, store.config]);

    return (
        <FormProvider {...formMethods}>
            <form onSubmit={formMethods.handleSubmit(props.onSubmit)}>
                <div className="d-flex align-items-center justify-content-between">
                    <h5 className="mb-0">Konfiguracja</h5>
                    <Link to={R.customer}>
                        <button type="button" className="btn btn-sm btn-primary">Przejdź dalej</button>
                    </Link>
                </div>

                <hr/>
                <Select
                    name="width"
                    label="Szerokość drzwi"
                    options={[
                        {label: '"80"', value: 80},
                        {label: '"90"', value: 90},
                        {label: '"100"', value: 100},
                        {label: '"110"', value: 110},
                        {label: '"120"', value: 120},
                    ].filter(o => (o.value <= props.dimensions.width - 10) || o.value <= props.dimensions.width - 20)}
                />
                <Select
                    name="height"
                    label="Wysokość drzwi"
                    options={[
                        {label: '200 cm', value: 200},
                        {label: '205 cm', value: 205},
                        {label: '210 cm', value: 210},
                        {label: '215 cm', value: 215},
                        {label: '220cm', value: 220},
                    ].filter(o => o.value <= props.dimensions.height)}
                />
                {/*<Select*/}
                {/*    name="align"*/}
                {/*    label="Strona przylegania"*/}
                {/*    options={[*/}
                {/*        {label: 'Do lewej', value: 'left'},*/}
                {/*        {label: 'Na środku', value: 'center'},*/}
                {/*        {label: 'Do prawej', value: 'right'},*/}
                {/*    ]}*/}
                {/*/>*/}
                <Select
                    name="panelCount"
                    label="Typ widoku"
                    options={options.panelCount}
                />
                <Select name="openingDirection" label="Kierunek otwierania" options={options.openingDirection}/>
                <Datalist
                    name="product"
                    label="Model"
                    options={store.products.map(p => ({label: p.title, value: p.id, img: p.gallery?.cover?.urlSmall}))}
                />
                <Datalist
                    name="color"
                    label="Kolorystyka"
                    options={options.color}
                />
                {/*<Checkbox name="biggerBottomBorder" label="Powiększona rama dolna"/>*/}
                <NumberInput name="topBorder" label="Wysokość ramy górnej (cm)" customProps={{type: 'number', min: 0, max: store.dimensions.height}}/>
                <NumberInput name="bottomBorder" label="Wysokość ramy dolnej (cm)" customProps={{type: 'number', min: 0, max: store.dimensions.height}}/>
                {/*<Checkbox name="topEnabled" label="Naśw"/>*/}
                <div className="mb-5"/>
                <h4>Opcje</h4>
                <hr/>
                <Select name="depth" label="Grubość" options={options.depth}/>
                <Select name="openingType" label="Sposób otwierania" options={options.openingType}/>

                <Select name="type" label="Rodzaj wykończenia" options={options.type}/>
                <Select name="doorstep" label="Próg" options={options.doorstep}/>
                <Select name="glass" label="Szklenie" options={options.glass}/>
                <Select name="lock" label="Zamek" options={options.lock}/>
                <Select name="border" label="Kolor okuc" options={options.border}/>
                <Select name="handle" label="Rodzaj klamki" options={options.handle}/>

                {/*<button className="btn btn-primary w-100">Zapisz</button>*/}
            </form>
        </FormProvider>
    )
}
